import request from '../plugins/axios'
// 获取公司列表
function CompanyList(data) {
    return request({
        url: '/company/list',
        method: 'post',
        data
    })
}
// 删除公司
function CompanyDel(data) {
    return request({
        url: '/company/delete',
        method: 'post',
        data
    })
}

// 保存
function CompanyUpdate(data) {
    return request({
        url: '/company/update',
        method: 'post',
        data
    })
}
//   添加
function CompanyAdd(data) {
    return request({
        url: '/company/add',
        method: 'post',
        data
    })
}

//   添加
function CompanyDetail(data) {
    return request({
        url: '/company/detail',
        method: 'post',
        data
    })
}

export {
    CompanyList,
    CompanyDel,
    CompanyUpdate,
    CompanyAdd,
    CompanyDetail
}
